import jsPDF from "jspdf";
import { Clipboard, FileText } from "lucide-react";

const JobShareActions = ({
    formData,
    department,
    skillsKnown = [],
    selectedBranches = [],
    allBranches = [],
    showSuccess,
    showError
}) => {

    // 🔹 SINGLE SOURCE OF TRUTH (Clipboard + PDF)
    const buildFormattedJobText = () => {
        const title = `${department?.toUpperCase() || "JOB"} JOB REQUIREMENT (${formData.jobReqId})`;

        return `
${title}

JOB OVERVIEW

Company Name : ${formData.companyName}
Job Location : ${formData.jobLocation}
Job Title : ${formData.jobTitle}
Job Description : ${formData.jobDescription || "-"}
Salary : ${formData.salary || "-"}

SKILLS REQUIRED
Skills : ${[
                ...(skillsKnown || []),
                ...(formData.additionalSkills
                    ? formData.additionalSkills
                        .split(",")
                        .map(s => s.trim())
                        .filter(Boolean)
                    : [])
            ].join(", ") || "-"
            }

ELIGIBILITY CRITERIA
Qualification : ${formData.qualification}
Passed Out Year : ${formData.passedOutYear}
Experience Required : ${formData.experienceRequired}

ADDITIONAL DETAILS
Bond : ${formData.bond}
${formData.additionalDetails ? `Note : ${formData.additionalDetails}` : ""}
Allowed Branches: ${selectedBranches.length === allBranches.length
                ? "All Branches"
                : selectedBranches.join(", ")
            }

INTERVIEW DETAILS
Mode of Interview : ${formData.modeOfInterview}
Interview Type : ${formData.interviewType}

${formData.interviewType === "Walk-in" ||
                formData.interviewType === "Pumo Scheduled Interview"
                ? `Interview Dates : ${formData.interviewDate}
Interview Location : ${formData.interviewLocation}`
                : ""
            }

${formData.interviewType === "Campus Drive"
                ? `Interview Date : ${formData.interviewDate}
Interview Time : ${formData.interviewTime}
Venue : ${formData.venue}`
                : ""
            }

${formData.interviewType === "Direct Apply"
                ? `Apply Link : ${formData.directApplyLink || "-"}`
                : ""
            }

CONTACT
For any Queries related to the requirement please contact :
${formData.createdBy} - ${formData.createdContact}

IMPORTANT: Applicable only for Pumo Technovation Students. DO NOT FORWARD TO OTHERS

`.trim();
    };

    // 📋 COPY TO CLIPBOARD
    const handleCopy = async () => {
        try {
            const text = buildFormattedJobText();
            await navigator.clipboard.writeText(text);
            showSuccess("Job requirement copied to clipboard");
        } catch (err) {
            console.error(err);
            showError("Failed to copy job requirement");
        }
    };

    // 📄 DOWNLOAD PDF (Professional layout)
    const handleDownloadPDF = () => {
        const doc = new jsPDF();
        const text = buildFormattedJobText();

        const marginX = 14;
        let cursorY = 20;

        // 🔹 Title
        doc.setFont("Times", "Bold");
        doc.setFontSize(14);
        doc.text(text.split("\n")[0], marginX, cursorY);

        cursorY += 10;

        // 🔹 Body
        doc.setFont("Times", "Normal");
        doc.setFontSize(11);

        const bodyText = text.split("\n").slice(1).join("\n");
        const lines = doc.splitTextToSize(bodyText, 180);

        doc.text(lines, marginX, cursorY);

        doc.save(`${formData.jobReqId || "job-requirement"}.pdf`);
    };

    return (
        <>
            <button
                type="button"
                className="edit-btn"
                onClick={handleCopy}
                title="Copy Job Requirement"
            >
                <Clipboard size={18} />
            </button>

            <button
                type="button"
                className="edit-btn"
                onClick={handleDownloadPDF}
                title="Download Job Requirement PDF"
            >
                <FileText size={18} />
            </button>
        </>
    );
};

export default JobShareActions;